import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface PhiHintLabelProps {
  readonly htmlFor: string;
  readonly label: string;
}

export function PhiHintLabel({ htmlFor, label }: PhiHintLabelProps): ReactElement {
  const { t } = useTranslation();
  const warning = t('patient.medicalHistory.phiWarning');
  return (
    <div className="flex items-center gap-1.5">
      <label
        htmlFor={htmlFor}
        className="block text-xs font-medium text-muted-foreground"
      >
        {label}
      </label>
      <TooltipProvider delayDuration={150}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              aria-label={t('patient.medicalHistory.phiWarningAria')}
              className="inline-flex h-4 w-4 items-center justify-center text-muted-foreground hover:text-foreground focus:outline-none focus-visible:ring-1 focus-visible:ring-ring rounded-sm"
            >
              <Info className="h-3.5 w-3.5" aria-hidden="true" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="top" className="max-w-xs">
            {warning}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
